import { ILocalAccount } from '@src/models/account';
import { AnyType } from '@src/models/common';
import { AES, enc } from 'crypto-js';

type TIdentity = string | number;
type TUpdate = Partial<ILocalAccount>;
interface IUpdateAccount {
  id: TIdentity;
  update: TUpdate;
}

class AccountClient {
  private name = '_c_u';
  private sk = 'asVg331g&21';
  //Версия
  private v = 'v1_';

  constructor() {}

  private getLSValue() {
    try {
      if (window !== undefined) {
        let value = localStorage.getItem(this.name) || '';
        if (!value.startsWith(this.v)) {
          return undefined;
        }

        value = value.replace(this.v, '');
        const bytes = AES.decrypt(value, this.sk);

        return JSON.parse(bytes.toString(enc.Utf8)) as ILocalAccount[];
      }
    } catch (error) {
      console.error('Ошибка парсинга!');
      return [];
    }
  }

  private setLSValue(value: ILocalAccount[]) {
    try {
      if (window !== undefined) {
        const valueString = JSON.stringify(value);
        const encrypt = AES.encrypt(valueString, this.sk).toString();
        localStorage.setItem(this.name, `${this.v}${encrypt}`);
      }
    } catch (error) {
      console.error('Ошибка парсинга!');
    }
  }

  /** Добавляет или мутируем аккаунт в списке и делаем его активным
   * @deprecated не используется
   */
  public setActiveAccount(v: ILocalAccount) {
    const list = this.getLSValue();
    let isFound = false;

    if (Array.isArray(list)) {
      const newList = list.map((acc) => {
        if (acc.id == v.id) {
          isFound = true;
          return v;
        } else return { ...acc, active: false };
      });

      !isFound && newList.push(v);
      this.setLSValue(newList);
    }
  }

  public deleteAccount(id: TIdentity) {
    const list = this.getLSValue();
    if (list) {
      const newList = list.filter((a) => a.id !== id);
      this.setLSValue(newList);
    }
  }

  public getAccountList() {
    return this.getLSValue() || [];
  }

  /** Обновляем данные в списке */
  public updateAccountList(updateList: AnyType[]) {
    this.setLSValue(updateList);
  }

  /**
   * Здесь {data} это любые прилинкованные аккаунты либо активный аккаунт
   * Поэтому мы проставляем linked: false, всем кого нет в {data} по умолчанию
   */
  public updateAccounts(data: IUpdateAccount | IUpdateAccount[]) {
    const dataArray = Array.isArray(data) ? data : [data];
    const list = this.getAccountList();
    const updateMap = new Map<TIdentity, TUpdate>(dataArray.map((a) => [a.id, { ...a.update, linked: true }]));

    let newList = list.reduce<ILocalAccount[]>((result, a) => {
      const newAccount = updateMap.get(a.id);

      if (newAccount) {
        a = { linked: false, ...a, ...newAccount };
        updateMap.delete(a.id);
      }
      result.push(a);
      return result;
    }, []);

    /** Значит есть кто-то, кто не добавлен в хранилище */
    if (updateMap.size) {
      const remainsList = Array.from(updateMap).map(([id, update]) => ({ id, ...update }));
      newList = [...newList, ...remainsList];
    }

    this.updateAccountList(newList);
  }

  public updateActiveCompany(name: string | null) {
    if (!name) return;

    const list = this.getAccountList();
    const newList = list.reduce<ILocalAccount[]>((result, a) => {
      if (a.active) {
        a.company = name;
      }

      result.push(a);

      return result;
    }, []);

    this.setLSValue(newList);
  }

  public unlinkAccounts() {
    const list = this.getAccountList();
    const newList = list.reduce<ILocalAccount[]>((result, a) => {
      a.linked = false;

      result.push(a);

      return result;
    }, []);

    this.updateAccountList(newList);
  }
}

/** Нам нужен единственный инстанс для работы LS */
export const AccountClientManager = Object.freeze(new AccountClient());
